import { addBreakpoint } from 'scripts/marmalade/functions/add-breakpoint';
import { addClassToDocumentAtScrollY } from 'scripts/marmalade/functions/add-class-at-scroll-y';
const header = document.querySelector('.js-header');
const headerContainer = document.querySelector('.js-header__container');
const headerNav = document.querySelector('.js-nav__list');
const hamburger = document.querySelector('.js-header__hamburger');
const quicklinks = document.querySelector('.js-quicklinks');
const quicklinksOverflow = document.querySelector('.js-quicklinks__overflow');
const quicklinksContent = document.querySelector('.js-quicklinks__content');
function headerBreakpointTest() {
  return headerContainer.clientWidth < headerNav.clientWidth;
}
function quicklinksBreakpointTest() {
  return quicklinksOverflow.clientWidth < quicklinksContent.clientWidth;
}

// Add a class at 100px scroll
addClassToDocumentAtScrollY('scrolled', 100);

// Add desktop class when the quicklinks aren't breaking
addBreakpoint(quicklinks, quicklinksBreakpointTest, 'desktop');

// Add a custom breakpoint function to the header
addBreakpoint(header, headerBreakpointTest, breaking => {
  hamburger.tabIndex = breaking ? 0 : -1;
  hamburger.ariaHidden = !breaking;
  header.classList.toggle('desktop', !breaking);
});